// Imported for documentation purposes only. Should be removed by the build process for
// being unused.
import { ECOMM_OVERRIDE_COOKIE_NAME } from './public';

/* eslint-disable prefer-destructuring -- Trying to destructure process.env
variables won't work due to the nature of webpack DefinePlugin. */
/** @see {@link https://nextjs.org/docs/pages/api-reference/next-config-js/env Next.js Environment Variables}. */

/**
 * The value that the {@link ECOMM_OVERRIDE_COOKIE_NAME} cookie must have in order to
 * force-enable ecommerce functionality.
 *
 * If this environment variable is not set, then ecommerce functionality enablement cannot
 * be overridden on the server-side. The value of this environment variable is intended to
 * be some manner of unguessable secret string. This value is irrelevant on the
 * client-side which relies only on the presence of the cookie, not its value.
 */
export const ECOMM_OVERRIDE_COOKIE_VALUE =
  process.env.ECOMM_OVERRIDE_COOKIE_VALUE;

export const ENHANCED_LOGGING = process.env.ENHANCED_LOGGING === 'true';

export const AWS_AUTH = process.env.AWS_AUTH;
export const AWS_AUTH_DEV = process.env.AWS_AUTH_DEV;
export const AWS_AUTH_QA = process.env.AWS_AUTH_QA;
export const AWS_AUTH_UAT = process.env.AWS_AUTH_UAT;
export const AWS_AUTH_PROD = process.env.AWS_AUTH_PROD;

export const ELASTIC_PATH_CLIENT_SECRET =
  process.env.ELASTIC_PATH_CLIENT_SECRET;

export const SENDGRID_API_KEY = process.env.SENDGRID_API_KEY;
export const SENDGRID_SENDER = process.env.SENDGRID_SENDER;
export const SENDGRID_PASSWORD_RESET_TEMPLATE =
  process.env.SENDGRID_PASSWORD_RESET_TEMPLATE;

export const DATADOG_API_KEY = process.env.NEXT_PRIVATE_DATADOG_API_KEY;
export const DATADOG_APP_KEY = process.env.NEXT_PRIVATE_DATADOG_APP_KEY;

export const CHASE_BASE_URL = process.env.CHASE_BASE_URL;
export const CHASE_MERCHANT_ID = process.env.CHASE_MERCHANT_ID;
export const CHASE_CONNECTION_USERNAME = process.env.CHASE_CONNECTION_USERNAME;
export const CHASE_CONNECTION_PASSWORD = process.env.CHASE_CONNECTION_PASSWORD;

export const DOMS_OAUTH_CLIENT_ID = process.env.DOMS_OAUTH_CLIENT_ID;
export const DOMS_OAUTH_CLIENT_SECRET = process.env.DOMS_OAUTH_CLIENT_SECRET;
export const DOMS_MAIL_BASE_URL = process.env.DOMS_MAIL_BASE_URL;
export const DOMS_AUTH_SIGNATURE_SALT = process.env.DOMS_AUTH_SIGNATURE_SALT;

export const HEADLESS_SITE_ID = process.env.HEADLESS_SITE_ID;

export const YOTPO_API_URL = process.env.YOTPO_API_URL;
export const YOTPO_API_KEY = process.env.YOTPO_API_KEY;
export const YOTPO_API_SECRET = process.env.YOTPO_API_SECRET;

export const DYNAMIC_YIELD_API_KEY = process.env.DYNAMIC_YIELD_API_KEY;
export const DYNAMIC_YIELD_API_KEY_AHNU =
  process.env.DYNAMIC_YIELD_API_KEY_AHNU ?? process.env.DYNAMIC_YIELD_API_KEY;

export const DYNAMIC_YIELD_API_KEY_TEVA =
  process.env.DYNAMIC_YIELD_API_KEY_TEVA ?? process.env.DYNAMIC_YIELD_API_KEY;

export const DYNAMIC_YIELD_API_KEY_HOKA =
  process.env.DYNAMIC_YIELD_API_KEY_HOKA ?? process.env.DYNAMIC_YIELD_API_KEY;

export const DYNAMIC_YIELD_API_KEY_UGG =
  process.env.DYNAMIC_YIELD_API_KEY_UGG ?? process.env.DYNAMIC_YIELD_API_KEY;

export const DYNAMIC_YIELD_API_KEY_UGGCOLLAB =
  process.env.DYNAMIC_YIELD_API_KEY_UGGCOLLAB ??
  process.env.DYNAMIC_YIELD_API_KEY;

export const SAFETECH_API_PASSWORD = process.env.SAFETECH_API_PASSWORD;

/** The private User Pool ID for the Next server-side Cognito client. */
export const COGNITO_USER_POOL_ID = process.env.COGNITO_USER_POOL_ID;

/** The private Client ID for the Next server-side Cognito client. */
export const COGNITO_CLIENT_ID = process.env.COGNITO_CLIENT_ID;

// AvaTax configs
export const AVATAX_USERNAME = process.env.AVATAX_USERNAME;
export const AVATAX_PASSWORD = process.env.AVATAX_PASSWORD;

export const AVATAX_COMPANY_CODE = process.env.AVATAX_COMPANY_CODE;

export const UPS_API_PASSWORD = process.env.UPS_API_PASSWORD;

export const PITNEYBOWES_API_KEY = process.env.PITNEYBOWES_API_KEY;

export const FORTER_API_KEY = process.env.FORTER_API_KEY;

export const EASYPOST_API_KEY = process.env.EASYPOST_API_KEY;

/**
 * Will have a value of `'true'` if app is being built.
 * Passed via the `build` command in `package.json`.
 */
export const BUILD_MODE_ENABLED = process.env.BUILD_MODE_ENABLED;

/**
 * Will have a value of `'1'` if code is running in a Continuous Integration environment.
 * Also exposed by Vercel during builds.
 *
 * @see [System Environment Variables | Vercel Docs](https://vercel.com/docs/projects/environment-variables/system-environment-variables#system-environment-variables)
 */
export const CI = process.env.CI;

/** The API key to use with the Sitemap Getter API. */
export const SITEMAP_GETTER_API_KEY = process.env.SITEMAP_GETTER_API_KEY;

export const VERCEL = process.env.VERCEL;

/** Will have a value of `'true'` if filesystem cache is allowed. */
export const ALLOW_FILESYSTEM_CACHE = process.env.ALLOW_FILESYSTEM_CACHE;

/**
 * The Apple Pay Merchant Identity Certificate encoded in base64.
 * This certificate expires every 25 months and can be revoked.
 * @see {@link https://developer.apple.com/apple-pay/Apple-Pay-Merchant-Integration-Guide.pdf}
 * @see {@link https://developer.apple.com/documentation/ApplePayontheWeb/maintaining-your-environment}
 *
 * The certificate can be encoded using the `btoa` function in JavaScript.
 */
export const APPLE_PAY_CERT = !!process.env.APPLE_PAY_CERT_B64
  ? Buffer.from(process.env.APPLE_PAY_CERT_B64, 'base64')
  : undefined;

/**
 * Client secret to authenticate PayPal REST calls with.
 * @see https://developer.paypal.com/api/rest/#link-getclientidandclientsecret
 */
export const PAYPAL_CLIENT_SECRET = process.env.PAYPAL_CLIENT_SECRET;

/**
 * Username to use when authenticating PayPal NVP API calls.
 * @see https://developer.paypal.com/api/nvp-soap/apiCredentials/
 */
export const PAYPAL_NVP_USERNAME = process.env.PAYPAL_NVP_USERNAME;

/**
 * Password to use when authenticating PayPal NVP API calls.
 * @see https://developer.paypal.com/api/nvp-soap/apiCredentials/
 */
export const PAYPAL_NVP_PASSWORD = process.env.PAYPAL_NVP_PASSWORD;

/**
 * API Signature to use when authenticating PayPal NVP API calls.
 * @see https://developer.paypal.com/api/nvp-soap/apiCredentials/#api-signatures
 */
export const PAYPAL_NVP_SIGNATURE = process.env.PAYPAL_NVP_SIGNATURE;

/**
 * API Key for the Talon.One integration API.
 * @see https://docs.talon.one/integration-api
 */
export const TALONONE_API_KEY = process.env.TALONONE_API_KEY;

/**
 * SCAPI variables.
 * @see https://developer.salesforce.com/docs/commerce/commerce-api/overview
 */
export const SCAPI_SHORT_CODE = process.env.SCAPI_SHORT_CODE;
export const SCAPI_ORG_ID = process.env.SCAPI_ORG_ID;
export const SCAPI_PRIVATE_CLIENT_ID = process.env.SCAPI_PRIVATE_CLIENT_ID;
export const SCAPI_PRIVATE_CLIENT_SECRET =
  process.env.SCAPI_PRIVATE_CLIENT_SECRET;

/**
 * DataDome server variables.
 * @see https://docs.datadome.co/docs/nextjs#how-to-deploy-on-vercel-infrastructure
 */
export const DATADOME_SERVER_SIDE_KEY = process.env.DATADOME_SERVER_SIDE_KEY;

/**
 * The header name for the resolved `ConfiguredLocaleString`.
 *
 * **Note**: The header is expected to be set by the application middleware.
 * Therefore the header should not be read within middleware itself.
 */
export const DECA_RESOLVED_LOCALE_HEADER_NAME = 'X-DECA-Resolved-Locale';

/**
 * API Key for the Happy Returns integration.
 */
export const HAPPY_RETURNS_API_KEY = process.env.HAPPY_RETURNS_API_KEY;

/**
 * API Key for the Loqate integration.
 */
export const LOQATE_API_KEY = process.env.LOQATE_API_KEY;

/**
 * Whether the address search is biased towards the integration source criteria available.
 */
export const ADDRESS_SEARCH_BIAS_ENABLED =
  process.env.ADDRESS_SEARCH_BIAS_ENABLED;

/**
 * API Keys for the Attentive marketing SMS integration.
 * Each brand has its own Attentive company account and API key.
 * Brand-specific keys fall back to the default `ATTENTIVE_API_KEY`.
 * @see https://docs.attentive.com/openapi/reference/tag/Subscribers/
 */
export const ATTENTIVE_API_KEY = process.env.ATTENTIVE_API_KEY;
export const ATTENTIVE_API_KEY_UGG =
  process.env.ATTENTIVE_API_KEY_UGG ?? process.env.ATTENTIVE_API_KEY;
export const ATTENTIVE_API_KEY_TEVA =
  process.env.ATTENTIVE_API_KEY_TEVA ?? process.env.ATTENTIVE_API_KEY;
export const ATTENTIVE_API_KEY_HOKA =
  process.env.ATTENTIVE_API_KEY_HOKA ?? process.env.ATTENTIVE_API_KEY;
export const ATTENTIVE_API_KEY_AHNU =
  process.env.ATTENTIVE_API_KEY_AHNU ?? process.env.ATTENTIVE_API_KEY;
export const ATTENTIVE_API_KEY_UGGCOLLAB =
  process.env.ATTENTIVE_API_KEY_UGGCOLLAB ?? process.env.ATTENTIVE_API_KEY;

/**
 * Token required to authorize server cache purge requests via API.
 * This is used for the webhook handler to purge the content cache as well as the server cache purge API.
 */
export const SERVER_CACHE_PURGE_TOKEN = process.env.SERVER_CACHE_PURGE_TOKEN;

/**
 * Whether to opt out of the top-level suspense boundary.
 * If set to `true`, the `TopLevelSuspense` boundary will simply return the children.
 */
export const OPT_OUT_TOP_LEVEL_SUSPENSE =
  process.env.OPT_OUT_TOP_LEVEL_SUSPENSE;
